import React from 'react'
import { useTranslation } from 'react-i18next'

import { Modal } from '@/components/Modal'
import { BaseView, BaseText } from '@/components/base'
import { AppButton } from '@/components/AppButton'

interface ModalRequiredPermissionProps {
  title: string
  description: string
  isVisible: boolean
  onConfirm: () => void
  onCancel: () => void
  confirmText?: string
  cancelText?: string
}

export const ModalRequiredPermission: React.FC<
  ModalRequiredPermissionProps
> = ({
  title,
  description,
  isVisible,
  onConfirm,
  onCancel,
  confirmText,
  cancelText,
}) => {
  const { t } = useTranslation()

  return (
    <Modal isOpen={isVisible} onClose={onCancel} title={title}>
      <BaseView
        flex={1}
        px={12}
        py={24}
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          minHeight: '200px',
        }}
      >
        {/* Description */}
        <BaseView center>
          <BaseText
            fontSize={16}
            fontFamily="regular"
            color="label.default"
            textAlign="center"
            style={{
              lineHeight: '22px',
              opacity: 0.8,
            }}
          >
            {description}
          </BaseText>
        </BaseView>

        {/* Actions */}
        <BaseView gap={12} style={{ marginTop: 32 }}>
          <AppButton
            type="primaryGradient"
            label={confirmText || 'Settings'}
            onPress={onConfirm}
          />
          <AppButton
            type="secondaryGray"
            label={cancelText || t('form:actions.cancel', 'Cancel')}
            onPress={onCancel}
          />
        </BaseView>
      </BaseView>
    </Modal>
  )
}
